import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useAuth } from "@/lib/auth";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SubscriptionContext = createContext(null);

export function SubscriptionProvider({ children }) {
  const { user } = useAuth();
  const [state, setState] = useState({
    loading: true,
    has_access: false,
    trial_active: false,
    trial_days_left: 0,
    trial_end: null,
    subscription: null,
    demo_pairs: null,
  });

  const refresh = useCallback(async () => {
    if (!user) {
      setState({ loading: false, has_access: false, trial_active: false, trial_days_left: 0, trial_end: null, subscription: null, demo_pairs: null });
      return;
    }
    try {
      const { data } = await axios.get(`${API}/billing/subscription`);
      setState({ loading: false, ...data });
    } catch {
      setState({ loading: false, has_access: false, trial_active: false, trial_days_left: 0, trial_end: null, subscription: null, demo_pairs: null });
    }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <SubscriptionContext.Provider value={{ ...state, refresh }}>
      {children}
    </SubscriptionContext.Provider>
  );
}

export function useSubscription() {
  const ctx = useContext(SubscriptionContext);
  if (!ctx) throw new Error("useSubscription must be inside SubscriptionProvider");
  return ctx;
}
